export * from "./shared";

/**
 * WEB half of `utils/sentryHelpers`, seeded with the event-name map only.
 *
 * 🔴 **`sendCaptureEvent`, the function that consumes these names, is NOT uplifted and should not
 * be reached for.** It imports `@sentry/react` and — more awkwardly — `{ replay }` from the app's
 * ENTRY module, which core cannot import. Core code that wants to report an event uses the
 * effects bridge's `logEvent` instead, which the app is free to wire to `sendCaptureEvent`.
 */

/** Named events the app reports to its error tracker. Values are the event ids, sent verbatim. */
export const SENTRY_EVENTS = {
  primaryMigrationError: "primaryMigrationError",
  updateDownloadError: "updateDownloadError",
  updateIssue: "updateIssue",
  updateCancelled: "updateCancelled",
} as const;
